import React, { useMemo } from 'react';
import { isAllFeed } from '../utils';
import { useSelector } from 'react-redux';
import { getIsCategoryFilterApplied } from '../redux/selectors/options';
export const FeedInfoContext = /*#__PURE__*/ React.createContext({
    streamId: '',
    isFilteredBySubnav: false,
    isFakeAllFeed: false
});
FeedInfoContext.displayName = 'FeedInfoContext';
export const FeedInfoContextProvider = ({ streamId, children })=>{
    const isCategoryFilterApplied = useSelector(getIsCategoryFilterApplied);
    const isFakeAllFeed = isAllFeed(streamId);
    const feedInfoContextValue = useMemo(()=>({
            isFilteredBySubnav: isCategoryFilterApplied,
            isFakeAllFeed,
            streamId
        }), [
        isCategoryFilterApplied,
        isFakeAllFeed,
        streamId
    ]);
    return /*#__PURE__*/ React.createElement(FeedInfoContext.Provider, {
        value: feedInfoContextValue
    }, children);
};
